import { GWInsuredEvent } from './gw-insured-event.model';
import { FeatureToggles } from './feature-toggles.enum';

export class GWCreateInsuredEventRequest {
    public event: GWInsuredEvent;
    public featureToggles?: FeatureToggles[];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-create-insured-event-request.model.ts